import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { CollectsListPage, CollectViewPage, CollectCreationPage } from 'pages/ReverseLogistics';
import { ReverseLogisticProvider } from 'contexts/ReverseLogisticContext';
import { HistoryPickupsListPage } from 'pages/HistoryPickups/PickupsList';

const reverseLogisticsRoutes = ({
  isLoggedIn,
  location,
  hasPermissionTo,
}: RouterProps): RouteObject => ({
  path: 'logistica-reversa',
  element: isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: 'coletas',
      element: (
        <ReverseLogisticProvider>
          <CollectsListPage />
        </ReverseLogisticProvider>
      ),
    },
    {
      path: 'coletas/historico',
      element: hasPermissionTo(['HISTORY-PICKUPS.INDEX']) ? (
        <HistoryPickupsListPage />
      ) : (
        <Navigate to="/" />
      ),
    },
    {
      path: 'criar',
      element: <CollectCreationPage />,
    },
    {
      path: 'coleta/:id',
      element: <CollectViewPage />,
    },
  ],
});

export default reverseLogisticsRoutes;
